import { Segment } from 'component/Space/Segment'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import Curvy from 'page/ProfileScreen/assets/curvy.svg'
import Normal from 'page/ProfileScreen/assets/normal.svg'
import PlusSize from 'page/ProfileScreen/assets/plus-size.svg'
import Skinny from 'page/ProfileScreen/assets/skinny.svg'
import Slim from 'page/ProfileScreen/assets/slim.svg'
import { FC, SVGProps } from 'react'
import { opt } from 'store/opt'
import { store } from 'store/store'
import { BodyThickness } from 'type/Identity'

type Props = {
  size: BodyThickness
}

function getSvg(value: BodyThickness): FC<SVGProps<any>> | undefined {
  if (value === 'skinny') return Skinny
  if (value === 'slim') return Slim
  if (value === 'normal') return Normal
  if (value === 'curvy') return Curvy
  if (value === 'plus_size') return PlusSize
}

export const Thickness = observer(({ size }: Props) => {
  const { form } = store.profile
  const Svg = getSvg(size)

  const onClick = useLatestCallback(() => {
    form.setThickness(size)
  })

  const inner = <Vertical gap={2} pad={[0, 0, 0, 0]} center>
    {Svg && <Svg height={opt.stand ? 60 : 40} />}
  </Vertical>

  return <Segment height={opt.stand ? 72 : 48} active={form.thickness === size} action={onClick}>
    <span>{inner}</span>
  </Segment>
})
